import styled from "styled-components"
import { Button_s, Colors } from 'styles/app-styles'
import { AddRemoveRow_s, CarouselContent_s, CarouselSharedValue_s, SingleRowCarouselState_s } from 'components/table/carousel/carousel-styles'

export const AccountNumber_s = styled(SingleRowCarouselState_s)`
  display: flex;
  flex-direction: column;
  padding: 10px 0 0 20px;
  width: 200px;
  label { font-size: 14px; }
`

export const VacancyLossDetailed_s = styled.div`
`

export const VacancyCreditLoss_s = styled.div`
  font-family: 'Roboto', sans-serif;
  margin: -20px 15px 15px 15px;
  min-height: 380px;
  details {
    border: 1px solid ${Colors.towerGrey};
    &:nth-child(2){
      margin-top: -1px;
    }
  }
  summary {
    background: ${Colors.inputFocus};
    color: ${Colors.darkDenim};
    cursor: pointer;
    outline:none;
    padding: 10px;
  }
  hr {
    color: ${Colors.towerGrey};
  }
  p {
    margin-left: 25px;
  }
  .revenue-type-dropdown {
    width: 380px;
    .p-dropdown.p-component {
      width: 380px;
    }
  }
  ${Button_s}{
    margin: 10px 0 10px 30px;
  }
  ${CarouselContent_s}{
    .has-errors {
      border-bottom-width: 1px !important;
      border-bottom-color: ${Colors.colorDanger} !important;
    }
    padding: 10px 20px;
    > div {
      max-width: 100% !important;
    }
    hr + div > div:last-child {
      margin-top: 25px;
    }
    .percentage-overrides .checkbox-div {
      width: 150px;
    }
    ${CarouselSharedValue_s}{
      display: flex;
      margin-bottom: 20px;
      label { margin-bottom: 10px; }
      > div {
        display: flex;
        flex-direction: column;
        margin-right: 15px;
      }
    }
    ${VacancyLossDetailed_s}{
      ${AddRemoveRow_s}:first-of-type {
        padding-top: 25px;
      }
      ${AddRemoveRow_s} {
        height: 30px;
      }
      > div:last-child {
        flex-wrap: wrap;
      }
    }
  }
`
